import React from 'react';
import { GRID_SIZE } from '../types';

/**
 * Dragging nodes without re-rendering the app on every move: while a node is dragged, the
 * canvas moves it (and the nodes that go with it) on screen and redraws only their
 * connections; the node reports its new place once, when it is dropped. The nodes follow the
 * pointer freely and go to the grid when they are dropped.
 */
export interface CanvasNodeDrag {
    /** A drag of `id` starts; the canvas works out which nodes go with it. */
    begin: (id: string) => void;
    /** How far the dragged nodes are from where they started, in canvas units (not snapped). */
    move: (dx: number, dy: number) => void;
    /**
     * The drag is over: (dx, dy) is how far from their start the nodes settle, on the grid. The
     * node has reported its new place if that is not where it started.
     */
    end: (dx: number, dy: number) => void;
}

/** The grid line nearest a canvas coordinate (adding 0 turns a negative zero into a plain one). */
export const snapToGrid = (value: number): number => Math.round(value / GRID_SIZE) * GRID_SIZE + 0;

export const CanvasNodeDragContext = React.createContext<CanvasNodeDrag | null>(null);
